module.exports = __webpack_public_path__ + "img/完成.a29273d3.png";